import React from "react";
import { GridCell, gridConstants, GridContainer, GridFlexSpacer } from "../Grid";

interface LayoutMediumProps {
    children?: React.ReactNode;
}

export const LayoutMedium: React.FC<LayoutMediumProps> = ({ children }: LayoutMediumProps) => {
    return (
        <GridContainer>
            <GridFlexSpacer/>
            <GridCell
                medium_columns={gridConstants.column.TEN}
                large_columns={gridConstants.column.EIGHT}
            >
                {children}
            </GridCell>
            <GridFlexSpacer/>
        </GridContainer>
    );
};
